import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Sprig from "../components/Sprig";
import { useLang } from "../i18n/LanguageContext";
import usePageMeta from "../hooks/usePageMeta";

export default function How() {
  const { t } = useLang();
  usePageMeta(t("meta.how"), t("how.subtitle"));

  const couples = [
    { n: "1", t: t("how.c1t"), d: t("how.c1d") },
    { n: "2", t: t("how.c2t"), d: t("how.c2d") },
    { n: "3", t: t("how.c3t"), d: t("how.c3d") },
  ];
  const businesses = [
    { n: "1", t: t("how.b1t"), d: t("how.b1d") },
    { n: "2", t: t("how.b2t"), d: t("how.b2d") },
    { n: "3", t: t("how.b3t"), d: t("how.b3d") },
  ];

  return (
    <>
      <Navbar />
      <Wrap>
        <Header>
          <Sprig width={46} color="#C9B68E" style={{ display: "block", margin: "0 auto 22px" }} />
          <h1>{t("how.title")}</h1>
          <p>{t("how.subtitle")}</p>
        </Header>

        <Section>
          <h2>{t("how.couples")}</h2>
          <Steps>
            {couples.map((s) => (
              <Step key={s.n}>
                <span className="num">{s.n}</span>
                <div>
                  <strong>{s.t}</strong>
                  <p>{s.d}</p>
                </div>
              </Step>
            ))}
          </Steps>
          <Cta to="/">{t("how.ctaCouples")} →</Cta>
        </Section>

        <Divider />

        <Section>
          <h2>{t("how.businesses")}</h2>
          <Steps>
            {businesses.map((s) => (
              <Step key={s.n}>
                <span className="num">{s.n}</span>
                <div>
                  <strong>{s.t}</strong>
                  <p>{s.d}</p>
                </div>
              </Step>
            ))}
          </Steps>
          <Cta to="/list">{t("how.cta")} →</Cta>
        </Section>
      </Wrap>
      <Footer />
    </>
  );
}

const Wrap = styled.div`
  max-width: 760px;
  margin: 0 auto;
  padding: clamp(40px, 7vw, 80px) clamp(20px, 5vw, 40px) 70px;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: clamp(40px, 6vw, 64px);
  h1 {
    font-family: ${({ theme }) => theme.font.display};
    font-weight: 500;
    font-size: clamp(34px, 6vw, 56px);
    color: ${({ theme }) => theme.colors.ink};
  }
  p { margin: 16px auto 0; max-width: 480px; color: ${({ theme }) => theme.colors.inkSoft}; font-size: 17px; }
`;

const Section = styled.section`
  h2 {
    font-family: ${({ theme }) => theme.font.display};
    font-weight: 500;
    font-size: clamp(24px, 3.6vw, 32px);
    color: ${({ theme }) => theme.colors.green};
    margin-bottom: 24px;
  }
`;

const Steps = styled.div`
  display: flex;
  flex-direction: column;
  gap: 22px;
`;

const Step = styled.div`
  display: flex;
  gap: 18px;
  align-items: flex-start;
  .num {
    flex: 0 0 38px;
    height: 38px;
    border-radius: 50%;
    display: grid;
    place-items: center;
    background: ${({ theme }) => theme.colors.creamDeep};
    color: ${({ theme }) => theme.colors.green};
    font-family: ${({ theme }) => theme.font.display};
    font-size: 18px;
    font-weight: 600;
  }
  strong { font-size: 17px; display: block; margin-bottom: 4px; }
  p { color: ${({ theme }) => theme.colors.inkSoft}; font-size: 15px; line-height: 1.6; }
`;

const Cta = styled(Link)`
  display: inline-block;
  margin-top: 28px;
  background: ${({ theme }) => theme.colors.green};
  color: ${({ theme }) => theme.colors.cream};
  font-weight: 500;
  font-size: 15px;
  padding: 13px 28px;
  border-radius: 100px;
  transition: 0.25s;
  &:hover { background: ${({ theme }) => theme.colors.greenDeep}; }
`;

const Divider = styled.hr`
  border: none;
  border-top: 1px solid ${({ theme }) => theme.colors.hair};
  margin: clamp(40px, 6vw, 60px) 0;
`;
